import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleBasedRoute } from './RoleBasedRoute';
import AdminLayout from '../components/layouts/AdminLayout';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';

import StaffLayout from '../components/layouts/StaffLayout';
import TrainerLayout from '../components/layouts/TrainerLayout';
import AuthLayout from '../components/layouts/AuthLayout';

import RoleRedirect from '../components/common/RoleRedirect';

import PolicyManagement from '../pages/admin/policyManagement/PolicyManagement';
import StaffCourses from '../pages/staff/StaffCourses';
import StaffPolicies from '../pages/staff/policyManagement/StaffPolicies';


import TrainerCourses from '../pages/trainer/courseManagement/TrainerCourses';
import TrainerPolicies from '../pages/trainer/policyManagement/TrainerPolicies';



import Unauthorized from '../components/common/Unauthorized';

import CourseContent from '../pages/staff/CourseContent/Index';
import CourseFormPage from '../pages/trainer/courseManagement/addCourse/CourseFormPage';
import PolicyFormPage from '../pages/trainer/policyManagement/PolicyFormPage';
import TrainerStaffManagement from '../pages/trainer/staffManagement/TrainerStaffManagement';
import StaffManagement from '../pages/admin/staffManagement/StaffManagement';
import CourseManagement from '../pages/admin/courseManagement/CourseManagement';
import TrainerManagement from '../pages/admin/trainerManagement/TrainerManagement';
import AddTrainerForm from '../pages/admin/trainerManagement/AddTrainerForm';
import TrainerUpdates from '../pages/trainer/Updates/TrainerUpdates';
import ViewPolicy from '../pages/trainer/policyManagement/ViewPolicy';
import StaffUpdates from '../pages/staff/Updates/StaffUpdates';
import Feeds from '../pages/admin/feeds/Feeds';
import AdminProfile from '../pages/admin/profile/AdminProfile';
import StaffPerformanceFormPage from '../pages/trainer/sales/StaffPerformanceFormPage';
import TrainerSales from '../pages/trainer/sales/TrainerSales';
import Dashboard from '../pages/trainer/dashboard/Dashboard';
import TrainerProfile from '../pages/trainer/profile/TrainerProfile';
import StaffProfile from '../pages/staff/profile/StaffProfile';
import AdminDashboard from '../pages/admin/dashboard/Dashboard';
import StaffDashboard from '../pages/staff/dashboard/Dashboard';
import TrainerLeaderboard from '../pages/trainer/leaderboard/TrainerLeaderboard';
import StaffLeaderboars from '../pages/staff/leaderboard/StaffLeaderboars';
import ShowCertificate from '../pages/staff/ShowCertificate';
import CourseDetail from '../pages/admin/courseManagement/CourseDetail';
import TermsOfUse from '../components/common/TermsOfUse';
import TrainerNewsAndAnnouncements from '../pages/trainer/NewsManagement/TrainerNewsAndAnnouncements';
import FeedsFormPage from '../pages/trainer/NewsManagement/FeedsFormPage';


const AppRoutes = () => {
  return (
    // <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<RoleRedirect />} />
        <Route path="/terms&condition" element={<TermsOfUse />} />

        
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register-as-staff" element={<Register role="staff"/>} />
          <Route path="/register-as-manager" element={<Register role="manager" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

        </Route>
        
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {/* Admin Routes */}
          <Route element={<RoleBasedRoute allowedRoles={['admin']} />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/staff" element={<StaffManagement />} />
              <Route path="/admin/courses" element={<CourseManagement />} />
              <Route path="/admin/courses/:id" element={<CourseDetail />} />
              <Route path="/admin/managers" element={<TrainerManagement />} />
              <Route path="/admin/managers/add-manager" element={<AddTrainerForm />} />

              <Route path="/admin/feeds" element={<Feeds />} />
              <Route path="/admin/feeds/:id" element={<ViewPolicy />} />
              <Route path="/admin/policy" element={<PolicyManagement />} />
              <Route path="/admin/profile" element={<AdminProfile />} />
            </Route>
          </Route>
          
          {/* Staff Routes */}
          <Route element={<RoleBasedRoute allowedRoles={['staff']} />}>
            <Route element={<StaffLayout />}>
              <Route path="/staff/dashboard" element={<StaffDashboard />} />
              <Route path="/staff/certificate/:id" element={<ShowCertificate />} />
              <Route path="/staff/courses" element={<StaffCourses />} />
              <Route path="/staff/courses/:id" element={<CourseContent />} />
              <Route path="/staff/updates" element={<StaffUpdates/>} />
              <Route path="/staff/updates/:id" element={<ViewPolicy />} />
              <Route path="/staff/policies" element={<StaffPolicies />} />
              <Route path="/staff/policies/:id" element={<ViewPolicy />} />
              <Route path="/staff/leaderboard" element={<StaffLeaderboars />} />
              <Route path="/staff/profile" element={<StaffProfile />} />
              {/* <Route path="/staff/course" element={<CourseContent />} /> */}

            </Route>
          </Route>
          
          {/* Trainer Routes */}
          <Route element={<RoleBasedRoute allowedRoles={['manager']} />}>
            <Route element={<TrainerLayout />}>
              <Route path="/manager/dashboard" element={<Dashboard />} />
              <Route path="/manager/staff-management" element={<TrainerStaffManagement />} />
              <Route path="/manager/courses" element={<TrainerCourses />} />
              <Route path="/manager/courses/:id" element={<CourseDetail/>} />
              <Route path="/manager/policies" element={<TrainerPolicies />} />
              <Route path="/manager/news-announcement" element={<TrainerNewsAndAnnouncements />} />
              <Route path="/manager/policies/add-policy" element={<PolicyFormPage />} />
              <Route path="/manager/policies/edit-policy/:id/:feedId" element={<PolicyFormPage />} />
              
              <Route path="/manager/news-announcement/:type/:id" element={<FeedsFormPage />} />

              <Route path="/manager/updates/:id" element={<ViewPolicy />} />

              <Route path="/manager/leaderboard" element={<TrainerLeaderboard />} />
              <Route path="/manager/updates" element={<TrainerUpdates />} />
              <Route path="/manager/profile" element={<TrainerProfile />} />
              <Route path="/manager/courses/add-course" element={<CourseFormPage />} />
              <Route path="/manager/courses/edit-course/:id" element={<CourseFormPage />} />
              <Route path="/manager/sales" element={<TrainerSales />} />
              <Route path="/manager/sales/add-sales" element={<StaffPerformanceFormPage />} />
              <Route path="/manager/sales/edit-sales/:id" element={<StaffPerformanceFormPage />} />

            </Route>
          </Route>
        </Route>
        
        <Route path="/unauthorized" element={<Unauthorized />} />
   
      </Routes>
    // </BrowserRouter>
  );
};

export default AppRoutes;